<input #nameInput
       class="entity-rename-input"
       [(ngModel)]="draft"
       (blur)="onBlur()"
       (keydown)="onKeydown($event)"
       (click)="$event.stopPropagation()">
<span class="rename-save-icon"
      (mousedown)="keepFocus($event)"
      (click)="onSaveClick($event)"
      title="Save">&#x2713;</span>
<span class="rename-cancel-icon"
      (mousedown)="keepFocus($event)"
      (click)="onCancelClick($event)"
      title="Cancel">&#x2298;</span>
